<div class="ziro-admin-page-content">
  <div class="col-md-10 offset-md-1 pb-2 ziro-report-content">
    <ziro-breadcrumbs>
      <ziro-breadcrumb-card-item>
        <div>
          <p [innerHtml]="'tkey;reports.dn_availability.description.header' | escapeHtml"></p>
          <p>
            <a [routerLink]="[]" (click)="onGetFileClicked()">
              {{ 'tkey;reports.xlsx_export.button' | translate }}
            </a>
            <span>
              {{ 'tkey;reports.dn_availability.description.text' | translate }}
            </span>
          </p>
          <div [innerHTML]="'tkey;reports.dn_availability.description.text_2' | escapeHtml"></div>
          <p class="mb-0">
            <span [innerHtml]="'tkey;reports.dn_availability.description.refresh.text_1' | escapeHtml"></span>
            <ziro-button
              [label]="'tkey;reports.dn_availability.description.refresh.text_2'"
              (clicked)="refreshDialPlanGroups()"
              [buttonStyle]="buttonStyles.LINK"
            ></ziro-button>
            <span>{{ 'tkey;reports.dn_availability.description.refresh.text_3' | translate }}</span>
          </p>
        </div>
      </ziro-breadcrumb-card-item>
    </ziro-breadcrumbs>
    <ziro-loading-block [hidden]="!isLoading"></ziro-loading-block>
    @if (!isLoading) {
      <ziro-datatable
        [isCondensed]="true"
        [columns]="dataTableCols"
        [rowDataSource]="dnTableRows"
        [uniqueRowIdentifier]="'groupName'"
        [mainFilterPlaceholder]="
          ('tkey;reports.datatable.search_placeholder' | translate) +
          ('tkey;admin.dn_report.group_name.label' | translate) +
          ', ' +
          ('tkey;admin.site_management.site.site' | translate) +
          ', ' +
          ('tkey;menu.cluster' | translate) +
          '...'
        "
        [dataAutomation]="tableDataAutomation"
        [class]="'ziro-card'"
      >
        <ziro-datatable-multi-select-filter
          [label]="'tkey;admin.dn_report.available.filter.label'"
          [items]="availabilityFilterOptionsTexts"
          [matchFn]="isAvailableNumbersMatch"
          [dataAutomation]="'dn-inventory-filter'"
          [tableId]="tableDataAutomation"
        ></ziro-datatable-multi-select-filter>
      </ziro-datatable>
    }
  </div>
</div>

<ziro-bottom-nav data-automation="export-dn-report"></ziro-bottom-nav>
